import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import cn from 'classnames';
import { Box, Column, Row, SortableList, Switch, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import styles from './BusinessSwitcherEdit.module.scss';
import { BusinessSwitcherLogo } from './BusinessSwitcherLogo';
export const getEditTID = (parentTestId)=>getTestIds(parentTestId);
const ACCOUNT_REORDER_BI = {
    name: 'account_reordered'
};
export function BusinessSwitcherEdit(param) {
    let { items, onReorder, onToggleVisibility, testId } = param;
    const { t } = useLocaleKeys('navigation.bar.businessSwitcher');
    const { BusinessSwitcherEditTID } = useMemo(()=>getEditTID(testId), [
        testId
    ]);
    const handleReorder = useCallback((reordered)=>onReorder(reordered.map((item)=>item.id)), [
        onReorder
    ]);
    return /*#__PURE__*/ _jsx(Box, {
        className: styles.root,
        testId: testId,
        children: /*#__PURE__*/ _jsx(SortableList, {
            items: items,
            onReorder: handleReorder,
            getDragLabel: (item)=>t.dragAccountLabel({
                    accountName: item.name
                }),
            bi: ACCOUNT_REORDER_BI,
            testId: testId,
            renderItem: (item)=>/*#__PURE__*/ _jsxs(Row, {
                    alignItems: "center",
                    gap: 8,
                    className: styles.rowBody,
                    children: [
                        /*#__PURE__*/ _jsx(Box, {
                            className: cn(styles.noShrink, {
                                [styles.dimmed]: item.hidden
                            }),
                            children: /*#__PURE__*/ _jsx(BusinessSwitcherLogo, {
                                testId: BusinessSwitcherEditTID.Logo(item.id),
                                src: item.logoUrl
                            })
                        }),
                        /*#__PURE__*/ _jsxs(Column, {
                            className: cn(styles.rowText, {
                                [styles.dimmed]: item.hidden
                            }),
                            children: [
                                /*#__PURE__*/ _jsx(Typography, {
                                    variant: "paragraph1",
                                    skin: "secondary",
                                    weight: "light",
                                    ellipsis: true,
                                    className: styles.rowName,
                                    children: item.name
                                }),
                                item.subtext && /*#__PURE__*/ _jsx(Typography, {
                                    variant: "paragraph3",
                                    skin: "secondary",
                                    className: styles.rowSub,
                                    children: item.subtext
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Box, {
                            className: styles.hideToggle,
                            onPointerDown: (event)=>event.stopPropagation(),
                            children: /*#__PURE__*/ _jsx(Switch, {
                                bi: {
                                    name: 'business_switcher_toggle_visibility',
                                    data: {
                                        business_id: item.id,
                                        visibility: item.hidden ? 'visible' : 'hidden'
                                    }
                                },
                                testId: BusinessSwitcherEditTID.HideToggle(item.id),
                                checked: !item.hidden,
                                onChange: (_event, checked)=>onToggleVisibility(item.id, checked ? 'visible' : 'hidden'),
                                disabled: !item.canToggleHidden,
                                tooltip: item.canToggleHidden ? undefined : {
                                    title: t.cannotHideActiveAccount()
                                },
                                inputProps: {
                                    'aria-label': item.hidden ? t.showAccountLabel({
                                        accountName: item.name
                                    }) : t.hideAccountLabel({
                                        accountName: item.name
                                    })
                                }
                            })
                        })
                    ]
                })
        })
    });
}
